import { useEffect, useState } from 'react'
import { BREAKPOINTS } from '@mc/media'

const DESKTOP_QUERY = `(min-width: ${BREAKPOINTS.LG}px)`

/**
 * Whether the viewport is wide enough for the desktop nav CTA to be on screen.
 *
 * `AtWorkLink` mounts on every viewport and is only hidden by `d-none
 * d-lg-block` on its wrappers, so exposure has to be gated on the breakpoint
 * rather than on mount. `BREAKPOINTS.LG` is the same 960px as `$mc-bp-lg`
 * behind `d-lg-block` — they must stay in step.
 *
 * Returns `undefined` until the viewport is known, so callers can hold off
 * firing exposure. `@mc/media`'s `useMediaQuery` is not used here because it
 * reports `true` on first render for SSR safety, which would fire a spurious
 * mobile exposure before its own effect corrects the value.
 */
export const useIsDesktopViewport = () => {
  const [isDesktop, setIsDesktop] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    const mediaQuery = window.matchMedia(DESKTOP_QUERY)
    const update = () => setIsDesktop(mediaQuery.matches)

    update()
    mediaQuery.addEventListener('change', update)

    return () => mediaQuery.removeEventListener('change', update)
  }, [])

  return isDesktop
}
